import type { MouseEvent } from 'react';
import { routing } from '@/src/i18n/routing';

function isDedicatedLoginPath(pathname: string): boolean {
  let path = pathname;

  for (const locale of routing.locales) {
    const prefix = `/${locale}`;
    if (path === prefix) {
      path = '/';
      break;
    }
    if (path.startsWith(`${prefix}/`)) {
      path = path.slice(prefix.length);
      break;
    }
  }

  return path === '/login' || path.startsWith('/login/');
}

export function navigateToExternalAuth(url: string, pathname: string): void {
  if (isDedicatedLoginPath(pathname)) {
    window.location.replace(url);
    return;
  }

  window.location.assign(url);
}

export function replaceOnSameTabClick(event: MouseEvent<HTMLAnchorElement>, url: string, pathname: string): void {
  if (
    !isDedicatedLoginPath(pathname) ||
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    (event.currentTarget.target && event.currentTarget.target !== '_self')
  ) {
    return;
  }

  event.preventDefault();
  window.location.replace(url);
}
